import dadk from './src-localization-texts-da-dk.json.js';
import dede from './src-localization-texts-de-de.json.js';
import engb from './src-localization-texts-en-gb.json.js';
import enie from './src-localization-texts-en-ie.json.js';
import enus from './src-localization-texts-en-us.json.js';
import eses from './src-localization-texts-es-es.json.js';
import esus from './src-localization-texts-es-us.json.js';
import fifi from './src-localization-texts-fi-fi.json.js';
import frca from './src-localization-texts-fr-ca.json.js';
import frfr from './src-localization-texts-fr-fr.json.js';
import itit from './src-localization-texts-it-it.json.js';
import nbno from './src-localization-texts-nb-no.json.js';
import nlnl from './src-localization-texts-nl-nl.json.js';
import ptpt from './src-localization-texts-pt-pt.json.js';
import svse from './src-localization-texts-sv-se.json.js';

const resources = {
  "da-dk": dadk,
  "de-at": dede,
  "de-ch": dede,
  "de-de": dede,
  "en-au": enus,
  "en-ca": enus,
  "en-gb": engb,
  "en-ie": enie,
  "en-in": enus,
  "en-nz": enus,
  "en-sg": enus,
  "en-us": enus,
  "es-es": eses,
  "es-us": esus,
  "fi-fi": fifi,
  "fr-be": frfr,
  "fr-ca": frca,
  "fr-ch": frfr,
  "fr-fr": frfr,
  "it-ch": itit,
  "it-it": itit,
  "nb-no": nbno,
  "nl-be": nlnl,
  "nl-nl": nlnl,
  "pt-pt": ptpt,
  "sv-se": svse
};

export { resources };
//# sourceMappingURL=src-localization-index.js.map
